/* eslint-disable @typescript-eslint/naming-convention */
// library components
import { AppBar, Toolbar, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';

// custom components
import { ReactComponent as TotalLogo } from '../../common/assets/total-energies-logo.svg';
import { ReactComponent as CptnLogo } from '../../common/assets/cptn_logo_white.svg';


const Header = () => {

  const Search = styled('div')`
    position: 'relative';
    border-radius: ${(props) => props.theme.shape.borderRadius};
    background-color: ${(props) => props.theme.palette.common.white};
    &:hover {
      background-color: ${(props) => props.theme.palette.common.white}
    }
    margin-right: theme.spacing(2);
    margin-left: 0;
    width: '100%';
    ${(props) => props.theme.breakpoints.up('sm')} {
      margin-left: ${(props) => props.theme.spacing(3)};
      width: 'auto';
    }
  `;

  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));

  const StyledInputBase = styled(InputBase)`
    color: 'inherit';
    & .MuiInputBase-input {
      padding: ${(props) => props.theme.spacing(1, 1, 1, 0)}; 
      // vertical padding + font size from searchIcon
      padding-left: calc(1em + ${(props) => props.theme.spacing(1, 1, 1, 0)});
      transition: ${(props) => props.theme.transitions.create('width')};
      width: '100%';
      ${(props) => props.theme.breakpoints.up('md')} {
        width: '20ch';
      }
    }
  `;

  return (
    <AppBar position="static" elevation={2} sx={{ backgroundColor: '#102741', displayPrint:'none'}}>
      <Toolbar>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="menu2-appbar"
          aria-haspopup="true"
          // onClick={handleMenu}
          color="inherit"
        >
        </IconButton>
        <TotalLogo/>

        <Typography variant="h6" sx={{ ml: '2%', flexGrow: 1 }}>
          <CptnLogo fill='white'/>
        </Typography>

        <Search>
          <SearchIconWrapper>
          </SearchIconWrapper>
          <StyledInputBase
              placeholder="Search…"
              inputProps={{ 'ariaLabel': 'search' }}
          />
        </Search>

        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
        </Box>
        
        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
        </Box>
      </Toolbar>
    </AppBar>
  );
};


export default Header;